import { toItem } from '../mappers/item';
export const parseItems = res => ({
  ...res,
  paging: {
    cursor: res.data.nextPageToken
  },
  data: (res.data.items || []).map(toItem)
});